import React from "react";

const BlogCard = ({
  blog,
  isFirst = false,
  readButtonSvg,
  readButtonHoverSvg,
  circleDecorationSvg,
  onClick
}) => {
  // Format the publish date to a more readable format
  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-US', options);
  };

  return (
    <div
      className="flex flex-col rounded-lg overflow-hidden"
      style={{
        background: "linear-gradient(180deg, rgba(255, 255, 255, 0.65) 0%, rgba(255, 255, 255, 0.27) 100%)",
      }}
    >
      <div className="p-4 flex flex-col">
        {/* Blog Image */}
        <img
          src={blog.imageUrl}
          alt={blog.title}
          className="w-full h-auto object-cover"
        />
        
        {/* Blog Title */}
        <h3 
          className="mt-4 text-[#034B6A]"
          style={{
            fontFamily: "DM Sans",
            fontWeight: 600,
            fontSize: isFirst ? "29px" : "22px",
            lineHeight: isFirst ? "103%" : "117%",
            letterSpacing: isFirst ? "0%" : "-2%",
          }}
        >
          {blog.title}
        </h3>
        
        {/* Author */}
        <p 
          className="mt-2.5 text-[#034B6A]"
          style={{
            fontFamily: "DM Sans",
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "120%",
            letterSpacing: "0%",
          }}
        >
          {blog.author}
        </p>
        
        {/* Publish Date */}
        <p 
          className="mt-2 text-[#8E8E8E]"
          style={{
            fontFamily: "DM Sans",
            fontWeight: 400,
            fontSize: "14px",
            lineHeight: "120%",
            letterSpacing: "0%",
          }}
        >
          {formatDate(blog.publishedAt)}
        </p>
        
        {/* Spacer to push footer to bottom */}
        <div className="flex-grow"></div>
        
        {/* Footer with decoration and button */}
        <div className="mt-4 flex items-center justify-between">
          {/* Circle Decoration */}
          <img
            src={circleDecorationSvg}
            alt="Decoration"
            className="h-6 w-6"
          />
          
          {/* Read Now Button with hover effect */}
          <div className="relative group cursor-pointer" onClick={() => onClick(blog.url)}>
            <img
              src={readButtonSvg}
              alt="Read Now"
              className="transition-opacity duration-300 opacity-100 group-hover:opacity-0"
            />
            <img
              src={readButtonHoverSvg}
              alt="Read Now Hover"
              className="absolute inset-0 transition-opacity duration-300 opacity-0 group-hover:opacity-100"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogCard;